'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dPassword$0024 from "./presto.types$-Password$.js";
var $p;
/** @constructor */
function $c_Lpresto_UsersView$$anon$45(outer) {
  this.bPG = null;
  this.bPE = null;
  this.bPF = false;
  this.bPC = null;
  this.bPD = false;
  this.bPH = false;
  this.bPI = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bPG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_UsersView$$anon$45 as $c_Lpresto_UsersView$$anon$45 };
$p = $c_Lpresto_UsersView$$anon$45.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_UsersView$$anon$45;
/** @constructor */
function $h_Lpresto_UsersView$$anon$45() {
}
export { $h_Lpresto_UsersView$$anon$45 as $h_Lpresto_UsersView$$anon$45 };
$h_Lpresto_UsersView$$anon$45.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bPG;
});
$p.t = (function() {
  if ((!this.bPF)) {
    this.bPE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("password", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bPF = true;
  }
  return this.bPE;
});
$p.ag = (function() {
  if ((!this.bPD)) {
    this.bPC = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPassword$0024.$m_Lpresto_types$Password$().csW(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bPD = true;
  }
  return this.bPC;
});
$p.v = (function() {
  if ((!this.bPI)) {
    this.bPH = false;
    this.bPI = true;
  }
  return this.bPH;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_UsersView$$anon$45 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_UsersView$$anon$45, "presto.UsersView$$anon$45", ({
  V4: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_UsersView$$anon$45 as $d_Lpresto_UsersView$$anon$45 };
//# sourceMappingURL=presto.-Users-View$$anon$45.js.map
